import React, { Suspense } from "react";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Tab, Loader as Load } from "semantic-ui-react";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import Converter from "./components/convertidorMedidas";
import Incoterms from "./components/Incoterms";
import Calculador from "./components/calculadora";
import Container from "./components/ContainerSpecifications";
// import Contenedor from "./components/Contenedor";

function LogisticsTools(props) {
  return (
    <ContentWrapper>
      <div className="content-heading">
        <legend className="legendBasic">
          <i className='demo-icon icon-10abr23-iconosmagicdome-12_'></i>

          {/* <img
            style={{ margin: "-6px 6px 1px" }}
            alt=""
            src="https://magiclog.blob.core.windows.net/europartnerspic/Icono_herramientas-logisticas.svg"
            height="28"
            width="28"
          ></img> */}
          {props.t("logistic_tools")}
        </legend>
      </div>

      <Tab
        loading={true}
        menu={{
          secondary: true,
          className: "wrapped",
          pointing: true,
          style: { fontSize: "14px" },
        }}
        menuPosition="right"
        panes={[
          {
            menuItem: props.t("measurement_convert"),
            render: () => (
              <Suspense fallback={<Load />}>
                <Converter />
              </Suspense>
            ),
          },
          {
            menuItem: props.t("incoterms"),
            render: () => (
              <Suspense fallback={<Load />}>
                <Incoterms />
              </Suspense>
            ),
          },
          {
            menuItem: props.t("cargo_calculator"),
            render: () => (
              <Suspense fallback={<Load />}>
                <Calculador />
              </Suspense>
            ),
          },
          {
            menuItem: props.t("containers_specifications"),
            render: () => (
              <Suspense fallback={<Load />}>
                <Container />
              </Suspense>
            ),
          },
          // {
          //   menuItem: props.t("especifications"),
          //   render: () => (
          //     <Suspense fallback={<Load />}>
          //       <Contenedor />
          //     </Suspense>
          //   ),
          // },
        ]}
      />
      <br></br>
      <br></br>
      <div className='paddin-footer-5em' />
    </ContentWrapper>
  );
}

export default withNamespaces()(withRouter(LogisticsTools));
